module.exports = __webpack_public_path__ + "static/media/power_production_gauge.572cdea3.svg";